const initialState = {
    data: null,

};
export const IsAuthorizeDocumentReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ISAUTHORIZE_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'ISAUTHORIZE_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default IsAuthorizeDocumentReducer;